<form [formGroup]="formGroup" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective">
  <div class="mt-3">
    <div class="zusammenfassung-section" *ngIf="produkt.Daten">
      <div class="row">
        <div class="col col-xs-12 col-sm-8">
          <h6>Beschreibung des Geb&auml;udes</h6>
        </div>
        <div class="col col-xs-12 col-sm-4 text-right">
          <button mat-button class="button--primary" (click)="zusammenfassungService.korrektur($event, '#daten-hauptgebaeude', korrekturEvent)">Korrektur</button>
        </div>
        <div class="col col-xs-12 col-sm-12" *ngIf="showProduktEigenheim || showProduktBuendel">
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Bauweise:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ Bauweisen.get(produkt.Daten.BauweiseId) }}
            </div>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-6">
          Bewilligungsjahr:
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ produkt.Daten.Bewilligungsjahr }}
        </div>
        <div class="col col-xs-12 col-sm-12" *ngIf="isWohnung">
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Wohnung mit Garten:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ produkt.Daten.WohnungGarten | boolToJaNein }}
            </div>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-6">
          Gebäude in Hochwasserzone mit hoher Gefährdung (HQ30):
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ produkt.Daten.GebaeudeHochwasserzone | boolToJaNein }}
        </div>
        <div class="col col-xs-12 col-sm-12" *ngIf="showProduktHaushalt || showProduktBuendel">
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Top-Haushalt:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ produkt.Daten.TopHaushalt | boolToJaNein }}
            </div>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-12" *ngIf="showProduktEigenheim || showProduktBuendel">
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Top-Eigenheim:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ produkt.Daten.TopEigenheim | boolToJaNein }}
            </div>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-12" *ngIf="showProduktHaushalt || showProduktBuendel">
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Ausstattungsvariante:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ Einrichtungen.get(produkt.Daten.Einrichtung)  }}
            </div>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-12" *ngIf="showProduktEigenheim || showProduktBuendel">
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Leitungswasserschäden:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ produkt.Daten.LeitungswasserschaedenAusschliessen? 'nicht mitversichert (Standardschutz)': 'mitversichert (Vollschutz)'  }}
            </div>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-12" *ngIf="isWohnung">
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Wohnfläche:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ produkt.Daten.WohnnutzFlaecheQm  }} m²
            </div>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-12" *ngIf="!isWohnung">
          <div class="row">
            <div class="col col-xs-12 col-sm-12">
              <strong>Wohnfläche</strong>
            </div>
            <div class="col col-xs-12 col-sm-6">
              Fläche Erdgeschoß:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ produkt.Daten.ErdgeschossFlaecheQm  }} m²
            </div>
            <div class="col col-xs-12 col-sm-12" *ngIf="produkt.Daten.ErsterStockFlaecheQm !== null">
              <div class="row">
                <div class="col col-xs-12 col-sm-6">
                  Fläche 1. Stock:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  {{ produkt.Daten.ErsterStockFlaecheQm  }} m²
                </div>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-12" *ngIf="produkt.Daten.ZweiterStockFlaecheQm !== null">
              <div class="row">
                <div class="col col-xs-12 col-sm-6">
                  Fläche 2. Stock:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  {{ produkt.Daten.ZweiterStockFlaecheQm  }} m²
                </div>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-12" *ngIf="produkt.Daten.MansardeFlaecheQm !== null">
              <div class="row">
                <div class="col col-xs-12 col-sm-6">
                  Fläche Mansarde:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  {{ produkt.Daten.MansardeFlaecheQm  }} m²
                </div>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-12" *ngIf="produkt.Daten.KellerFlaecheQm !== null">
              <div class="row">
                <div class="col col-xs-12 col-sm-6">
                  Fläche Keller:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  {{ produkt.Daten.KellerFlaecheQm  }} m²
                </div>
              </div>
            </div>
            <div class="col col-xs-12 col-sm-12" *ngIf="produkt.Daten.WohnkellerFlaecheQm !== null && produkt.Daten.WohnkellerFlaecheQm !== 0">
              <div class="row">
                <div class="col col-xs-12 col-sm-6">
                  Fläche Wohnkeller:
                </div>
                <div class="col col-xs-12 col-sm-6">
                  {{ produkt.Daten.WohnkellerFlaecheQm  }} m²
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-3" *ngIf="produkt.Daten && produkt.Daten.Nebengebaeude.length > 0">
    <div class="zusammenfassung-section">
      <div class="row">
        <div class="col col-xs-12 col-sm-8">
          <h6>Nebengebäude</h6>
        </div>
        <div class="col col-xs-12 col-sm-4 text-right">
          <button mat-button class="button--primary" (click)="zusammenfassungService.korrektur($event, '#daten-nebengebaeude', korrekturEvent)">Korrektur</button>
        </div>
      </div>
      <div class="row" *ngFor="let nebengebaeude of produkt.Daten.Nebengebaeude">
        <div class="col col-xs-12 col-sm-12">
          <strong>{{ nebenGebaeudeArten.get(nebengebaeude.GebaeudeArt) }}</strong>
        </div>
        <div class="col col-xs-12 col-sm-6">
          Fläche:
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ nebengebaeude.FlaecheQm }} m²
        </div>
        <div class="col col-xs-12 col-sm-6">
          Bauweise:
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ Bauweisen.get(nebengebaeude.BauweiseId) }}
        </div>
        <div class="col col-xs-12 col-sm-6">
          Variante:
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ Varianten.get(nebengebaeude.Variante) }}
        </div>
      </div>
    </div>
  </div>
  <div class="mt-3">
    <div class="zusammenfassung-section">
      <div class="row">
        <div class="col col-xs-12 col-sm-8">
          <h6>Versicherungssummen</h6>
        </div>
        <div class="col col-xs-12 col-sm-4 text-right">
          <button mat-button class="button--primary" (click)="zusammenfassungService.korrektur($event, '#berechnung', korrekturEvent)">Korrektur</button>
        </div>
        <div class="col col-xs-12 col-sm-12" *ngIf="hvResult.HoechsthaftungssummeHaushalt">
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Versicherungssumme Haushalt:
            </div>
            <div class="col col-xs-12 col-sm-2 text-right">
              <span class="custom_currency">{{ hvResult.HoechsthaftungssummeHaushalt | customCurrency: 0 }}</span>
            </div>
            <div class="col u-hidden-xs col-sm-4 u-visible-sm">
            </div>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-12" *ngIf="hvResult.HoechsthaftungssummeEigenheim">
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Versicherungssumme Eigenheim Hauptgebäude:
            </div>
            <div class="col col-xs-12 col-sm-2 text-right">
              <span class="custom_currency text-right">{{ hvResult.HoechsthaftungssummeEigenheim | customCurrency: 0 }}</span>
            </div>
            <div class="col u-hidden-xs col-sm-4 u-visible-sm">
            </div>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-12" *ngIf="produkt.Daten && produkt.Daten.Nebengebaeude.length > 0" >
          <div class="row" *ngFor="let nebengebaeude of hvResult.Nebengebaeude">
            <div class="col col-xs-12 col-sm-6">
              Versicherungssumme {{ nebengebaeude.GebaeudeArt }}
            </div>
            <div class="col col-xs-12 col-sm-2 text-right">
              <span class="custom_currency text-right">{{ nebengebaeude.Hoechsthaftungssumme | customCurrency: 0 }}</span>
            </div>
            <div class="col u-hidden-xs col-sm-4 u-visible-sm">
            </div>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-12" *ngIf="!!hvResult.HoechsthaftungssummeEigenheim">
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Versicherungssumme Haus- und Grundstückshaftpflicht:
            </div>
            <div class="col col-xs-12 col-sm-2 text-right">
              <span class="custom_currency text-right">{{ produkt.Erweiterungen?.ErhoehungVersicherungssummeEigenheim? '€ 5.000.000,-': '€ 2.500.000,-' }}</span>
            </div>
            <div class="col u-hidden-xs col-sm-4 u-visible-sm">
            </div>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-12" *ngIf="!!hvResult.HoechsthaftungssummeHaushalt">
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Versicherungssumme Privathaftpflicht:
            </div>
            <div class="col col-xs-12 col-sm-2 text-right">
              <span class="custom_currency text-right">{{ produkt.Erweiterungen?.ErhoehungVersicherungssummeHaushalt? '€ 5.000.000,-': '€ 2.500.000,-' }}</span>
            </div>
            <div class="col u-hidden-xs col-sm-4 u-visible-sm">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-3">
    <div class="zusammenfassung-section" *ngIf="produkt.Erweiterungen">
      <div class="row">
        <div class="col col-xs-12 col-sm-8">
          <h6>Erweiterungen</h6>
        </div>
        <div class="col col-xs-12 col-sm-4 text-right">
          <button mat-button class="button--primary" (click)="zusammenfassungService.korrektur($event, '#erweiterungen', korrekturEvent)">Korrektur</button>
        </div>
        <div class="col col-xs-12 col-sm-6">
          Hundehaftpflicht:
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ !produkt.Erweiterungen.HaftpflichtAnzahlHunde || produkt.Erweiterungen.HaftpflichtAnzahlHunde === 0 ? 'Nein' :
          produkt.Erweiterungen.HaftpflichtAnzahlHunde === 1 ? '1 Hund':
            produkt.Erweiterungen.HaftpflichtAnzahlHunde.toString() + ' Hunde'}}
        </div>
        <div class="col col-xs-12 col-sm-6">
          Weitere Personen in der Privathaftpflicht hinzufügen:
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ !produkt.Erweiterungen.HaftpflichtAnzahlWeiterePersonen || produkt.Erweiterungen.HaftpflichtAnzahlWeiterePersonen === 0 ? 'Nein' :
          produkt.Erweiterungen.HaftpflichtAnzahlWeiterePersonen === 1 ? '1 Person':
            produkt.Erweiterungen.HaftpflichtAnzahlWeiterePersonen.toString() + ' Personen'}}
        </div>
        <div class="col col-xs-12 col-sm-6">
          Sicherheitseingangstür gemäß ÖNORM B5338:
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ produkt.Erweiterungen.SicherheitsEingangstuer | boolToJaNein }}
        </div>
        <div class="col col-xs-12 col-sm-6">
          VSÖ-geprüfte Alarmanlage:
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ produkt.Erweiterungen.Alarmanlage | boolToJaNein }}
        </div>
        <div class="col col-xs-12 col-sm-6">
          Aufbewahrung von Wertsachen und Bargeld im Safe:
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ getSafeText()  }}
        </div>
        <div class="col col-xs-12 col-sm-6">
          Selbstbehalt von <div class="custom_currency">€ 150,-</div> im Schadensfall:
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ produkt.Erweiterungen.Selbstbehalt | boolToJaNein }}
        </div>
      </div>
    </div>
  </div>
  <div class="mt-3" *ngIf="pakete && pakete.length > 0">
    <div class="zusammenfassung-section">
      <div class="row">
        <div class="col col-xs-12 col-sm-8">
          <h6>Zusatzpakete</h6>
        </div>
        <div class="col col-xs-12 col-sm-4 text-right">
          <button mat-button class="button--primary" (click)="zusammenfassungService.korrektur($event, '#zusatzpakete', korrekturEvent)">Korrektur</button>
        </div>
      </div>
      <div class="row" *ngFor="let paket of pakete">
        <div class="col col-xs-12 col-sm-12">
          <strong>{{ paket.Titel }}</strong>
        </div>
        <div class="col col-xs-12 col-sm-12" *ngIf="paket.VersicherungssummeId">
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Versicherungssumme:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ getVersicherungssummenText(paket) }}
            </div>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-12" *ngIf="paket.GeltungsbereicheVersicherungssummeId">
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Versicherungssumme:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ getVersicherungssummenGeltungsbereichText(paket) }}
            </div>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-12" *ngIf="paket.HasLocationIndustrieRisiko">
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Name:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ paket.Partner.Vorname }} {{ paket.Partner.Nachname }} ({{ paket.Partner.Geburtsdatum | date }})
            </div>
          </div>
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Adresse:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ zusammenfassungService.strasseHausnummerStiegeStockTuer(paket.Partner.Adresse.Strasse, paket.Partner.Adresse.Hausnummer, paket.Partner.Adresse.Stiege, paket.Partner.Adresse.Stock, paket.Partner.Adresse.Tuernummer ) }}
            </div>
          </div>
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              PLZ / Ort:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ paket.Partner.Adresse.Plz }} {{ paket.Partner.Adresse.Ort }}
            </div>
          </div>
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Telefonnummer:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ paket.Partner.Telefonnummer }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-3" *ngIf="(showProduktEigenheim || showProduktBuendel)">
    <div class="zusammenfassung-section">
      <div class="row">
        <div class="col col-xs-12 col-sm-8">
          <h6>Antragsinformationen</h6>
        </div>
        <div class="col col-xs-12 col-sm-4 text-right">
          <button mat-button class="button--primary" (click)="zusammenfassungService.korrektur($event, '#antrag_gebaeudetyp_dach', korrekturEvent)">Korrektur</button>
        </div>
        <div class="col col-xs-12 col-sm-6">
          Gebäudetyp:
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ GebaeudeTypen.get(hvAntragComponent.gebaudeartDachComponent.gebaeudetyp.value) }}
        </div>
        <div class="col col-xs-12 col-sm-6">
          Dachung:
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ Dachungen.get(hvAntragComponent.gebaudeartDachComponent.dachung.value) }}
        </div>
      </div>
    </div>
  </div>
  <div class="mt-3">
    <div class="zusammenfassung-section">
      <div class="row">
        <div class="col col-xs-12 col-sm-8">
          <h6>Allgemeine Fragen</h6>
        </div>
        <div class="col col-xs-12 col-sm-4 text-right">
          <button mat-button class="button--primary" (click)="zusammenfassungService.korrektur($event, '#antrag_weiterefragen', korrekturEvent)">Korrektur</button>
        </div>
        <div class="col col-xs-12 col-sm-12" *ngIf="produktart !== heimvorteilProduktarten.Haushalt">
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Rohbaudeckung:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ hvAntragComponent?.rohbaudeckung.value | toCapLetter }}
            </div>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-6">
          Wurde Ihnen bereits die Versicherung der beantragten Risiken gekündigt, abgelehnt oder einvernehmlich gelöst?
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ hvAntragComponent?.antragWeitereFragenComponent?.kuendigungRisiken.value | toCapLetter }}
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ expertMode ? 'Wurde schon einmal eine '+ hvAntragComponent?.versicherungsArt +' abgeschlossen?' : 'Hatten Sie schon einmal eine '+hvAntragComponent?.versicherungsArt+'?' }}
        </div>
        <div class="col col-xs-12 col-sm-6">
          {{ this.hvAntragComponent?.antragWeitereFragenComponent?.vorversicherung.value | toCapLetter }}
        </div>
        <div class="col col-xs-12 col-sm-12">
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Vinkulierung vorhanden?
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ hvAntragComponent?.vinkulierung.value | toCapLetter }}
            </div>
          </div>
        </div>
        <div class="col col-xs-12 col-sm-12" *ngIf="hvAntragComponent?.vinkulierung.value === 'ja'">
          <div class="row">
            <div class="col col-xs-12 col-sm-6">
              Gläubiger:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ hvAntragComponent?.glaeubigerVinkulierung.value }}
            </div>
            <div class="col col-xs-12 col-sm-6">
              Geschäftszahl:
            </div>
            <div class="col col-xs-12 col-sm-6">
              {{ hvAntragComponent?.geschaeftszahlVinkulierung.value }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row zusammenfassung-misc-questions">
    <div class="col col-xs-12 col-sm-12">
      <app-textarea #_besondereAnmerkungen [parentFormGroupDirective]="parentFormGroupDirective" [control]="besondereAnmerkungen" id="besondereAnmerkungen" label="Besondere Anmerkungen:"></app-textarea>
    </div>
    <div class="col col-xs-12 col-sm-12">
      <app-vereinbarung-kommunikation [parentFormGroupDirective]="parentFormGroupDirective" [vereinbarungKommunikation]="vereinbarungKommunikation" [antrag]="true" [showVereinbarungKommunikation]="!expertMode" [expertMode]="expertMode"></app-vereinbarung-kommunikation>
      <div class="input_checkbox">
        <app-datenschutz-policy [parentFormGroupDirective]="parentFormGroupDirective" [datenschutzPolicy]="datenschutzPolicyAntrag" [showDatenschutzPolicy]="!expertMode" [produktArt]="produktart"></app-datenschutz-policy>
        <mat-checkbox formControlName="allgemeineVertragsgrundlagen">
          <ng-container *ngIf="produktart === heimvorteilProduktarten.Haushalt">
          {{ expertMode ? 'Der Versicherungsnehmer erkennt die' : 'Ich erkenne die' }} <a href="https://www.hdi.at/downloads/bedingungen/Allgemeine_Vertragsgrundlagen_HH_2023.pdf" class="textLink" target="blank">allgemeinen Vertragsgrundlagen</a> und die <a href="https://www.hdi.at/services/downloads/" class="textLink" target="_blank">spartenbezogenen Versicherungsbedingungen</a> für das gewählte Versicherungsprodukt/die gewählten Versicherungsprodukte an. *
          </ng-container>
          <ng-container *ngIf="produktart === heimvorteilProduktarten.Eigenheim">
            {{ expertMode ? 'Der Versicherungsnehmer erkennt die' : 'Ich erkenne die' }} <a href="https://www.hdi.at/downloads/bedingungen/Allgemeine_Vertragsgrundlagen_EH_2023.pdf" class="textLink" target="blank">allgemeinen Vertragsgrundlagen</a> und die <a href="https://www.hdi.at/services/downloads/" class="textLink" target="_blank">spartenbezogenen Versicherungsbedingungen</a> für das gewählte Versicherungsprodukt/die gewählten Versicherungsprodukte an. *
          </ng-container>
          <ng-container *ngIf="produktart === heimvorteilProduktarten.Buendel">
            {{ expertMode ? 'Der Versicherungsnehmer erkennt die' : 'Ich erkenne die' }} allgemeinen Vertragsgrundlagen für die <a href="https://www.hdi.at/downloads/bedingungen/Allgemeine_Vertragsgrundlagen_HH_2023.pdf" class="textLink" target="blank">Haushalts-</a> und <a href="https://www.hdi.at/downloads/bedingungen/Allgemeine_Vertragsgrundlagen_EH_2023.pdf" class="textLink" target="blank">Eigenheimversicherung</a> sowie die <a href="https://www.hdi.at/services/downloads/" class="textLink" target="_blank">spartenbezogenen Versicherungsbedingungen</a> für das gewählte Versicherungsprodukt/die gewählten Versicherungsprodukte an. *
          </ng-container>
        </mat-checkbox>
        <mat-error *ngIf="allgemeineVertragsgrundlagen.hasError('required') && (allgemeineVertragsgrundlagen.touched || parentFormGroupDirective.submitted)">{{ 'CONFIRMREQUIRED' | translate }}</mat-error>
      </div>
    </div>
  </div>
</form>
